import script from "./FlowingDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlowingDetail.vue?vue&type=script&lang=ts&setup=true"

import "./FlowingDetail.vue?vue&type=style&index=0&id=1316bdce&lang=scss"
import "./FlowingDetail.vue?vue&type=style&index=1&id=1316bdce&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1316bdce"]])

export default __exports__